<ng-container *transloco="let t; prefix: 'orders.newCustomer'">
<div class="new-customer-step">
  @if (showHeader()) {
    <ord-new-customer-header />
  }

  @switch (flow.step()) {
    @case ('search') {
      <form class="company-search" [formGroup]="form" (ngSubmit)="search()">
        <div class="company-search-intro">
          <span class="title-medium-emphasized">{{ t('heading') }}</span>
          <span class="company-search-description body-large">
            {{ t('descriptionBeforeRegistry') }} <span class="body-large-emphasized">{{ t('registryName') }}</span> {{ t('descriptionAfterRegistry') }}
          </span>
        </div>

        <div class="company-search-fields">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('companyName') }}</mat-label>
            <input matInput formControlName="ragioneSociale" [placeholder]="t('companyNamePlaceholder')" autocomplete="organization">
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('taxCode') }}</mat-label>
            <input matInput formControlName="codiceFiscale" [placeholder]="t('taxCodePlaceholder')" maxlength="16" autocapitalize="characters" spellcheck="false">
            @if (taxCodeError) {
              <i matSuffix class="fa-regular fa-circle-exclamation tax-code-error-icon" aria-hidden="true"></i>
              <mat-hint class="tax-code-error">{{ t('taxCodeError') }}</mat-hint>
            } @else {
              <mat-hint>{{ t('taxCodeHint') }}</mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('vatNumber') }}</mat-label>
            <input matInput formControlName="partitaIva" [placeholder]="t('vatNumberPlaceholder')" inputmode="numeric" maxlength="11" spellcheck="false">
            <mat-hint>{{ t('vatNumberHint') }}</mat-hint>
          </mat-form-field>
        </div>

        @if (flow.loading()) {
          <div class="search-status" role="status" [attr.aria-label]="t('searching')"><ui-loading-spinner /></div>
        }

        <div class="company-search-footer">
          @if (noResults()) {
            <ord-new-customer-banner>
              <span class="body-medium">
                {{ t('noResultsDescription') }}
                <button type="button" class="link-button body-medium" (click)="createManually()">{{ t('createManually') }}</button>
              </span>
            </ord-new-customer-banner>
          }

          <div class="company-search-actions">
            <button matButton="filled" type="submit" [disabled]="!canSearch || flow.loading()">{{ t('search') }}</button>
          </div>
        </div>
      </form>
    }
    @case ('results') {
      <ord-new-customer-results />
    }
    @case ('detail') {
      <ord-new-customer-company-detail />
    }
    @case ('manual') {
      <ord-new-customer-manual />
    }
    @case ('deliveries') {
      <ord-new-customer-deliveries />
    }
    @case ('deliveryForm') {
      <ord-new-customer-delivery-form />
    }
    @case ('zones') {
      <ord-new-customer-zones />
    }
    @case ('contact') {
      <ord-new-customer-contact />
    }
    @case ('bank') {
      <ord-new-customer-bank />
    }
    @case ('note') {
      <ord-new-customer-note />
    }
    @case ('gdpr') {
      <ord-new-customer-gdpr />
    }
  }
</div>
</ng-container>
